import { currentUiLanguage, uiText } from "../../site/ui-language.js";
// Presentation only: version keys, URLs and progress storage remain unchanged.
export function versionPresentation(option, index, nativeLanguage) {
  const arabic = ["arabic", "ar", "العربية"].includes(String(nativeLanguage || "").trim().toLowerCase());
  if (!arabic) return { label: uiText(currentUiLanguage(), option.label), title: option.title };
  const raw = String(option.label || option.versionKey || "").trim();
  const base = /^(?:default|standard|أساسي)$/i.test(raw) || option.versionKey === "default";
  const number = /^(?:version|v)[\s_-]*(\d+)$/i.exec(raw) || /^(?:version|v)[\s_-]*(\d+)$/i.exec(String(option.versionKey));
  const label = base ? "أساسي" : number ? `معدّل ${Math.max(1, Number(number[1])-1)}` : `معدّل ${Math.max(1, index)}`;
  const title = String(option.title || "").replace(/\bDefault\b/gi, "أساسي").replace(/\bVersion\s*(\d+)\b/gi, (_, n) => `معدّل ${Math.max(1, Number(n)-1)}`);
  return { label, title };
}
